import { render, staticRenderFns } from "./CreateDatabase.vue?vue&type=template&id=66f5d34a&"
import script from "./CreateDatabase.vue?vue&type=script&lang=ts&"
export * from "./CreateDatabase.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports